import React from 'react';
import { BulkHolderInfo } from '@components/forms/bulk-holder/bulk-holder-info';
import { BulkHolderSelectType } from '@components/forms/bulk-holder/bulk-holder-select-type';
import { STEP_INFO, STEP_SELECT_TYPE } from '@constants/process-steps';

import type { BulkHolderStepsProps } from './bulk-holder-steps.type';

export const BulkHolderSteps: React.FC<BulkHolderStepsProps> = ({
  step,
  setStep,
  passId,
  isLoading,
  onSubmit,
  onClose,
  onSelectSingle,
  isNominative,
  triggerValidation,
  passOptions,
}) => {
  return (
    <>
      {step === STEP_SELECT_TYPE && (
        <BulkHolderSelectType
          onContinue={() => setStep(STEP_INFO)}
          onSelectSingle={onSelectSingle}
          passId={passId}
          passOptions={passOptions}
        />
      )}
      {step === STEP_INFO && (
        <BulkHolderInfo
          onContinue={onSubmit}
          handleClose={onClose}
          isLoading={isLoading}
          isNominative={isNominative}
          triggerValidation={triggerValidation}
        />
      )}
    </>
  );
};
